/**
 * Stream type which will be played by the player for the video session.
 */
export enum ConvivaStreamType {
  UNKNWON = 'UNKNOWN',
  LIVE = 'LIVE',
  VOD = 'VOD',
}
